var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(740 2203)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-740 -2203)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.984,3.484V1.5H3.307V3.484H5.292V4.807H3.307V6.792H1.984V4.807H0V3.484ZM3.969,7.453V5.469H5.953V3.484h4.63l1.21,1.323h2.1A1.327,1.327,0,0,1,15.214,6.13v7.938a1.327,1.327,0,0,1-1.323,1.323H3.307a1.327,1.327,0,0,1-1.323-1.323V7.453ZM8.6,13.407A3.307,3.307,0,1,0,5.292,10.1,3.309,3.309,0,0,0,8.6,13.407ZM6.482,10.1A2.117,2.117,0,1,0,8.6,7.982,2.114,2.114,0,0,0,6.482,10.1Z",
    transform: "translate(-733 -2196.5)",
    fill: "#494d7d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.4df6654d067aef667bad7fc6989a3729.svg";
export { ForwardRef as ReactComponent };